import { CallMessageModel } from "./CallMessageModel";
import { CallSessionModel } from "./CallSessionModel";
import { WebsocketEventModel } from "./WebsocketEventModel";

export class CallRoomModel {
  roomId: string;
  createdAt: number;
  clientId: string;
  customerPhoneNumber: string;
  customerName: string;
  roomName?: string;
  csId?: string;
  status: CallRoomStatus;
  remark?: string;
  expirationTime?: number;
  type?: string;
  csName?: string;
  tags?: string;
  priority?: string;
  completedAt?: number;
  shortId?: string;
  isTransfer?: boolean;
  remoteId?: string;
  constructor(_model: CallRoomModel) {
    this.roomId = _model.roomId;
    this.shortId = _model.shortId;
    this.createdAt = _model.createdAt;
    this.clientId = _model.clientId;
    this.customerPhoneNumber = _model.customerPhoneNumber;
    this.customerName = _model.customerName;
    this.status = _model.status;
    this.remark = _model.remark;
    this.expirationTime = _model.expirationTime;
    this.type = _model.type;
    this.roomName = _model.roomName;
    this.csName = _model.csName;
    this.tags = _model.tags;
    this.priority = _model.priority;
    this.completedAt = _model.completedAt;
    this.isTransfer = _model.isTransfer;
    this.remoteId = _model.remoteId;
  }
}

export enum CallRoomQueryStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  QUEUE = "QUEUE",
  ASSIGNED = "ASSIGNED",
}

export enum CallRoomStatus {
  CLOSED = "CLS",
  OPEN = "OPN",
  QUEUE = "QUE",
  HANDLE_BY_BOT = "BOT",
}

export class CallRoomSessionModel {
  session?: CallSessionModel;
  room: CallRoomModel;
  clientId?: string;
  sdp?: string;
  callMessage?: CallMessageModel;

  constructor(_model: CallRoomSessionModel) {
    if (!_model.room) {
      throw new Error("Required properties missing in CallRoomSessionModel");
    }

    this.session = _model.session;
    this.room = _model.room;
    this.clientId = _model.clientId;
    this.sdp = _model.sdp;
    this.callMessage = _model.callMessage;
  }
}

export class IncomingCallModel extends CallRoomSessionModel {
  isLoading: boolean;

  constructor(model: IncomingCallModel | WebsocketEventModel) {
    if (model instanceof WebsocketEventModel) {
      // Transform WebsocketEventModel to CallRoomSessionModel format
      const sessionModel: CallRoomSessionModel = {
        session: model.session,
        room: model.room,
        clientId: model.clientId,
      };
      super(sessionModel);
    } else {
      super(model);
    }

    this.isLoading = false;
  }
}

export enum RoomType {
  PHONE = "phone",
  WHATSAPP = "whatsapp",
  ALL = "all",
}

export class CallRoomListModel {
  room: CallRoomModel;
  session: CallSessionModel[];

  constructor(model: CallRoomListModel) {
    this.room = model.room;
    this.session = model.session;
  }
}
